import Vue from 'vue';
import SkyMailchimp from './sky-mailchimp';

Vue.component('sky-mailchimp', SkyMailchimp);

export default SkyMailchimp;



// WEBPACK FOOTER //
// ./scripts/sky-mailchimp/index.js